import ecommerce from '../assets/images/ecommerce.png';

const Ecommerce = () => {
  return (
    <div>
      <a href='#projects'><strong>Ecommerce</strong> App</a>
      <img src={ecommerce} alt='ecommerce' className='' />
    </div>
  )
}

export default Ecommerce;